import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('stock-reminder/index', {params});
    },
    getStockReminder(params) {
        return Service().get('stock-reminder/get-stock-reminder', {params});
    },
    show(id) {
        return Service().get('stock-reminder/show/'+id);
    },
    create(params) {
        return Service().post('stock-reminder/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('stock-reminder/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('stock-reminder/delete/'+id);
    },
    getSetting() {
        return Service().get('stock-reminder/setting');
    },
    saveSetting(params) {
        return Service().post('stock-reminder/setting', params);
    },
    sendNow() {
        return Service().post('stock-reminder/send-now');
    },
}